<template>
  <div>
    <el-card shadow="hover">
      <div class="head-tit">商户信息管理</div>
    </el-card>
    <el-card shadow="hover">
      <!-- <el-form ref="form" :model="merchantInfo" label-width="90px" :disabled="true">
        <el-row>
          <el-col :span="12">
            <el-form-item label="商户编号">
              <el-input v-model="merchantInfo.yctCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商户名称">
              <el-input v-model="merchantInfo.yctName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="所在地区">
              <el-cascader
                ref="cascader"
                v-model="merchantInfo.yctRegion"
                :props="cascader"
                placeholder="请选择所在地区"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="详细地址">
              <el-input v-model="merchantInfo.yctAddress"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="负责人">
              <el-input v-model="merchantInfo.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="绑定手机">
              <el-input v-model="merchantInfo.phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="生效时间">
              <el-date-picker v-model="merchantInfo.yctBeginTime" type="datetime"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="失效时间">
              <el-date-picker v-model="merchantInfo.yctEndTime" type="datetime"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>-->
      <el-tabs v-model="tabActiveName">
        <el-tab-pane label="基础信息" name="first">
          <el-form ref="form" :model="merchantInfo" label-width="90px" :disabled="true">
            <el-row>
              <el-col :span="12">
                <el-form-item label="商户编号">
                  <el-input v-model="merchantInfo.yctCode"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="商户名称">
                  <el-input v-model="merchantInfo.yctName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="所在地区">
                  <el-cascader
                    ref="cascader"
                    v-model="merchantInfo.yctRegion"
                    :props="cascader"
                    placeholder="请选择所在地区"
                  ></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="详细地址">
                  <el-input v-model="merchantInfo.yctAddress"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="负责人">
                  <el-input v-model="merchantInfo.name"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="绑定手机">
                  <el-input v-model="merchantInfo.phone"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="生效时间">
                  <el-date-picker v-model="merchantInfo.yctBeginTime" type="datetime"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="失效时间">
                  <el-date-picker v-model="merchantInfo.yctEndTime" type="datetime"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="小程序设置" name="second">
          <el-form ref="form" :model="miniProgramData" label-width="90px" :disabled="true">
            <el-form-item label="商户名称">{{miniProgramData.merchantName}}</el-form-item>
            <el-form-item label="小程序名称">
              <span>{{miniProgramData.miniProgramName}}</span>
              <div class="inline-block" @click="againBind">重新绑定</div>
              <div class="inline-block" @click="syncInfo">
                同步信息
                <span style="color: #333;">(完成授权)</span>
              </div>
            </el-form-item>
            <el-form-item label="APPID">{{miniProgramData.appid}}</el-form-item>
            <el-form-item label="主体名称">{{miniProgramData.subjectName}}</el-form-item>
            <!-- <el-form-item label="二维码URL">
              <el-link
                type="primary"
                :underline="false"
                @click="toQrCodeUrl(miniProgramData.qrCodeUrl)"
              >{{miniProgramData.qrCodeUrl}}</el-link>
            </el-form-item> -->
          </el-form>

          <div class="remark">备注：小程序绑定授权后请点击【同步信息】按钮，否则小程序无法登录。</div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import merchantManage from '@/store/merchantManage/index'
import { SHOWTENANT, GETAUTHORIZATIONINFO, GETCOMPONENTURL, SYNCINFO } from '@/store/merchantManage/types.js'
import wareManage from '@/store/wareManage/index'
import { GETCITY } from '@/store/wareManage/types.js'

export default {
  name: 'merchantManage',
  data () {
    return {
      tabActiveName: 'first',
      cascader: {
        select: null,
        lazy: true,
        lazyLoad: this.lazyLoad
      },
      miniProgramData: {
        merchantName: '中通集团',
        miniProgramName: '标序云仓',
        appid: 'wxea5e70b0ad5ab7e1',
        subjectName: '中通集团有限公司',
        qrCodeUrl: '123456789123456789123456789'
      }
    }
  },
  computed: {
    merchantInfo () {
      // merchantManage.state.merchantInfo.yctRegion = merchantManage.state.merchantInfo.yctRegion.split(',')
      return merchantManage.state.merchantInfo
    },
    cityList () {
      return wareManage.state.cityList
    }
  },
  mounted () {
    this.getMerchantInfo()
    this.getMiniProgramData()
  },
  methods: {
    getMerchantInfo () {
      let params = { yctCode: this.$route.params.yctCode }
      this.$store.dispatch(SHOWTENANT, params)
    },
    getMiniProgramData () {
      let params = { yctCode: this.$route.params.yctCode }
      this.$store.dispatch(GETAUTHORIZATIONINFO, params).then(res => {
        let D = res.obj
        if (D) {
          this.miniProgramData = {
            appid: D.yaaAuthorizerAppid,
            merchantName: D.yctName,
            miniProgramName: D.yaaNickName,
            subjectName: D.yaaPrincipalName,
            qrCodeUrl: D.yaaQrcodeUrl
          }
        }
      })
    },
    lazyLoad (node, resolve) {
      let { value } = node
      value = value || 0
      this.getcity(value, this.cascader.select)
      setTimeout(() => {
        resolve(this.cityList)
      }, 300)
    },
    getcity (parentCode = 0, type) {
      let params = {
        parentCode,
        type
      }
      this.$store.dispatch(GETCITY, params)
    },
    againBind () {
      this.$confirm('重新绑定前，请确定您已经将新小程序的原始ID提交平台工作人员，否则将无法绑定？', '提示', {
        confirmButtonText: '知道了',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch(GETCOMPONENTURL).then(res => {
          if (res.obj) {
            window.location.href = res.obj
          }
        })
      })
    },
    syncInfo () {
      if (!this.miniProgramData.appid) {
        this.$message({
          message: '同步失败，请先绑定小程序',
          type: 'success'
        })
        return
      }
      let params = { yctCode: this.$route.params.yctCode }
      this.$store.dispatch(SYNCINFO, params).then(res => {
        if (res.success) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getMiniProgramData()
        }
      })
    },
    toQrCodeUrl (url) {
      window.open(url)
    }
  }

}
</script>

<style scoped>
.remark{
  color: #999;
  font-size: 13px;
}
.inline-block{
  display: inline-block;
  color: #409eff;
  padding-left: 30px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/page/merchantManage/merchantInfo.vue